import React from "react";
import { Link } from "react-router-dom";

const ErrorPage = ({ status }) => {
  let title = "An error occurred!";
  let message = "Something went wrong!";

  if (status === 500) {
    message = "Oops, something went wrong";
  }
  if (status === 404) {
    title = "Not found";
    message = "Could not find resource or page";
  }
  if (status === 401) {
    title = "Unauthorized";
    message = "You need to be logged in to access this page";
  }

  if (status === 403) {
    title = "Forbidden";
    message = "You do not have permission to access this page.";
  }
  return (
    <main className="grid place-items-center bg-gray-200 min-h-screen px-6 py-24 sm:py-32 lg:px-8">
      <div className="text-center">
        <p className=" text-9xl font-bold text-indigo-600">{status}</p>
        <h1 className="mt-4 text-4xl font-bold tracking-tight text-gray-900 sm:text-5xl">
          {title}
        </h1>
        <p className="mt-6 text-2xl leading-7 text-gray-600">{message}</p>
        {status === 500 && (
          <p className="mt-6 text-xl leading-7 text-gray-600">
            Try to refresh this page or feel free to contact us if problem
            persists
          </p>
        )}

        {status === 401 && (
          <div className="mt-6 text-xl leading-7 text-gray-600">
            Please{" "}
            <Link to="/login" className="text-indigo-600 underline">
              log in
            </Link>{" "}
            to continue.
          </div>
        )}

        {status === 403 && (
          <div className="mt-6 text-xl leading-7 text-gray-600">
            You do not have permission to access this page. If you think this is
            a mistake, please{" "}
            <Link to="/support" className="text-indigo-600 underline">
              contact support
            </Link>
            .
          </div>
        )}

        {status !== 500 && (
          <div className="mt-10 flex items-center justify-center gap-x-6">
            <Link
              to="/" //  change this based on user profile
              className="rounded-md bg-indigo-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
            >
              Go back home
            </Link>
          </div>
        )}
      </div>
    </main>
  );
};

export default ErrorPage;
